// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"73025359","500":"5f11228e","590":"1debdb44"}[chunkId] + ".chunk.css";
};